import store from '@/app/store/store';

export async function isSignedIn(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    await store.dispatch('auth/fetchUser');
    if (store.getters['auth/loggedIn'] === true) {
      if (
        (to.name !== 'invite' && to.name !== 'on-board')
        && (!store.getters['account/hasActiveAccount']
        || to.matched.some(record => record.meta.refreshAccount))
      ) {
        try {
          store.dispatch('toggleLoading', true, { root: true });
          await store.dispatch('account/refreshAccounts');
          store.dispatch('toggleLoading', false, { root: true });
          next();
        } catch (err) {
          // no account so user needs to create
          store.dispatch('toggleLoading', false, { root: true });
          next({
            path: '/on-board',
          });
        }
      } else {
        next();
      }
    } else {
      next({
        path: '/auth/sign-in',
        query: {
          ...to.query,
        },
      });
    }
  } else {
    next();
  }
}


export function isAdminUser(to, from, next) {
  if (to.name === 'admin') {
    if (store.getters['auth/isHeffronUser']) {
      next();
    } else {
      next({
        path: '/',
      });
    }
  } else {
    next();
  }
}

export function hasAuthActionNewPassword(to, from, next) {
  if (to.name === 'auth' && to.params.state === 'new-password') {
    if (store.getters['auth/hasAction'] && store.state.auth.action.challengeName === 'NEW_PASSWORD_REQUIRED') {
      next();
    } else {
      next({
        path: '/auth/sign-in',
      });
    }
  } else {
    next();
  }
}

export function hasAuthActionConfirmEmail(to, from, next) {
  if (to.name === 'auth' && to.params.state === 'confirm-email') {
    if (store.getters['auth/hasAction'] && store.state.auth.action.challengeName === 'EMAIL_VERIFICATION_REQUIRED') {
      next();
    } else {
      next({
        path: '/auth/sign-in',
      });
    }
  } else {
    next();
  }
}
